export default "__VITE_ASSET__CeR1Kcwo__"